import Vue from 'vue'
import Vuex from 'vuex'

/* Import Others Store's */
import auth from './security/auth'
import layout from './commons/layout'
import toolbars from './commons/toolbars'
import alert from './commons/alert'
import loading from './commons/loading'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: { auth, layout, toolbars, alert, loading },
    state: {
        /* USO COMPARTILHADO */
        urlServicesStore: null,
        objShared: {},
        objFilter: {},
        objSearch: {},
        objSelected: {},
        objProcess: {},
        applyFilter: false,
        resetFilter: false,
        activeSystem: '',
        action: ''
    },

    getters: {},
    mutations: {
        /*=============================================================================        
        * setSerialNumber
        * Serial Number para Autenticação
        =============================================================================*/
        setSerialNumber(state, payload) {
            console.log('Store', payload)
            state.serialNumber = payload
        },
        /*=============================================================================        
        * setUrlServicesStore
        * URL da API do serviço a ser consumido.
        =============================================================================*/
        setUrlServicesStore(state, payload) {
            state.urlServicesStore = payload
        },
        /*=============================================================================
        * setObjShared
        * Objeto responsavel por propagar as informações entre os components. 
        =============================================================================*/
        setObjShared(state, payload) {
            state.objShared = payload
        },
        /*=============================================================================
        * setObjSearch
        * Objeto responsavel por propagar as informações entre modals de search. 
        =============================================================================*/
        setObjSearch(state, payload) {
            state.objSearch = payload
        },
        /*=============================================================================
        * setObjFilter
        * Objeto responsavel por propagar as informações dos filtros aplicados. 
        =============================================================================*/
        setObjFilter(state, payload) {
            state.objFilter = payload
        },
        /*=============================================================================
        * setObjSelected
        * Objeto responsavel por propagar as informações do item selecionado. 
        =============================================================================*/
        setObjSelected(state, payload) {
            state.objSelected = payload
        },
        /*=============================================================================
        * setObjProcess
        * Objeto responsavel por propagar as informações do item selecionado. 
        =============================================================================*/
        setObjProcess(state, payload) {
            state.objProcess = payload
        },
        /*=============================================================================
        * setApplyFilter
        * Controla  o Fluxo de Execução dos Filtros da Aplicação 
        =============================================================================*/
        setApplyFilter(state, payload) {
            state.applyFilter = payload
        },
        /*=============================================================================
        * setResetFilter
        * Controla  o Fluxo de Execução dos Filtros da Aplicação 
        =============================================================================*/
        setResetFilter(state, payload) {
            state.resetFilter = payload
        },
        /*=============================================================================
        * setActiveSystem
        * Controla o sistema ativo para tratamento do menu entre outros fatores
        * (BPM, Streamline, etc) 
        =============================================================================*/
        setActiveSystem(state, payload) {
            state.activeSystem = payload
        },
        /*=============================================================================
        * setResetFilter
        * Controla  o Fluxo de Execução dos Filtros da Aplicação 
        =============================================================================*/
        setAction(state, payload) {
            state.action = payload
        },
    }
})
